export const noDataFound = `
# No Data was found

> [!INFO]
> Something went wrong try again later.
`;
